import { render, staticRenderFns } from "./DetectCustomerTypeCountry.vue?vue&type=template&id=dee6836a&"
import script from "./DetectCustomerTypeCountry.vue?vue&type=script&lang=js&"
export * from "./DetectCustomerTypeCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dee6836a')) {
      api.createRecord('dee6836a', component.options)
    } else {
      api.reload('dee6836a', component.options)
    }
    module.hot.accept("./DetectCustomerTypeCountry.vue?vue&type=template&id=dee6836a&", function () {
      api.rerender('dee6836a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/DetectCustomerTypeCountry.vue"
export default component.exports